/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Fixed_RatesInputs */

const en_admin_resource_form_fixed_rates = /** @type {(inputs: Admin_Resource_Form_Fixed_RatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fixed rates`)
};

const de_admin_resource_form_fixed_rates = /** @type {(inputs: Admin_Resource_Form_Fixed_RatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Festpreise`)
};

const es_admin_resource_form_fixed_rates = /** @type {(inputs: Admin_Resource_Form_Fixed_RatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precios fijos`)
};

const fr_admin_resource_form_fixed_rates = /** @type {(inputs: Admin_Resource_Form_Fixed_RatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix fixes`)
};

const nl_admin_resource_form_fixed_rates = /** @type {(inputs: Admin_Resource_Form_Fixed_RatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaste tarieven`)
};

/** @type {(inputs: Admin_Resource_Form_Fixed_RatesInputs) => LocalizedString} */
const it_admin_resource_form_fixed_rates = en_admin_resource_form_fixed_rates;

/** @type {(inputs: Admin_Resource_Form_Fixed_RatesInputs) => LocalizedString} */
const pt_br2_admin_resource_form_fixed_rates = en_admin_resource_form_fixed_rates;

/** @type {(inputs: Admin_Resource_Form_Fixed_RatesInputs) => LocalizedString} */
const pl_admin_resource_form_fixed_rates = en_admin_resource_form_fixed_rates;

/** @type {(inputs: Admin_Resource_Form_Fixed_RatesInputs) => LocalizedString} */
const hu_admin_resource_form_fixed_rates = en_admin_resource_form_fixed_rates;

/** @type {(inputs: Admin_Resource_Form_Fixed_RatesInputs) => LocalizedString} */
const ro_admin_resource_form_fixed_rates = en_admin_resource_form_fixed_rates;

/**
* | output |
* | --- |
* | "Fixed rates" |
*
* @param {Admin_Resource_Form_Fixed_RatesInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_fixed_rates = /** @type {((inputs?: Admin_Resource_Form_Fixed_RatesInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Fixed_RatesInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_fixed_rates(inputs)
	if (locale === "de") return de_admin_resource_form_fixed_rates(inputs)
	if (locale === "es") return es_admin_resource_form_fixed_rates(inputs)
	if (locale === "fr") return fr_admin_resource_form_fixed_rates(inputs)
	if (locale === "nl") return nl_admin_resource_form_fixed_rates(inputs)
	if (locale === "it") return it_admin_resource_form_fixed_rates(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_fixed_rates(inputs)
	if (locale === "pl") return pl_admin_resource_form_fixed_rates(inputs)
	if (locale === "hu") return hu_admin_resource_form_fixed_rates(inputs)
	return ro_admin_resource_form_fixed_rates(inputs)
});
export { admin_resource_form_fixed_rates as "admin.resource_form.fixed_rates" }